import { GroupChannel } from "@sendbird/chat/groupChannel";

export const PINNED = "p";
export const OFFICIAL = "o";

export const HELPDESK = "o";

export const channelStatus = (channel: GroupChannel | null) => {
  if (!channel) {
    return null;
  }

  if (channel.customType.includes(PINNED)) {
    return PINNED;
  }

  if (channel.customType.includes(OFFICIAL)) {
    return OFFICIAL;
  }

  if (channel.customType.includes(HELPDESK)) {
    return HELPDESK;
  }

  return null;
};
